import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import api from "@/lib/api";

/**
 * Zone 2 — Bande basse discrète (horizontale) en pied de home.
 * Rotation automatique si plusieurs items.
 */
export function HighlightBannerBottom() {
  const [items, setItems] = useState([]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    let alive = true;
    api.get("/home/highlights", { params: { zone: "bottom_banner" } })
      .then((res) => {
        if (!alive) return;
        setItems(res.data?.items || []);
      })
      .catch(() => {
        if (alive) setItems([]);
      });
    return () => { alive = false; };
  }, []);

  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => {
      setCurrent((c) => (c + 1) % items.length);
    }, 7000);
    return () => clearInterval(t);
  }, [items.length]);

  if (items.length === 0) return null;
  const item = items[current];
  const link = item.cta_url || "#";

  return (
    <div className="w-full mt-8" data-testid="home-highlight-bottom">
      <Link
        to={link}
        className="block group"
      >
        <div className="relative overflow-hidden rounded-lg border border-border/60 bg-background/95 backdrop-blur-sm shadow-sm hover:shadow-md transition-shadow">
          {item.image_url && (
            <div className="w-full aspect-[8/1] sm:aspect-[10/1] bg-muted overflow-hidden">
              <img
                src={item.image_url}
                alt={item.title || "Mise en avant"}
                className="w-full h-full object-cover object-center group-hover:scale-[1.02] transition-transform duration-500"
                loading="lazy"
              />
            </div>
          )}
          <div className="flex items-center gap-3 p-3 sm:p-4">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                {item.title && (
                  <h4 className="font-display font-semibold text-sm sm:text-base leading-tight truncate">{item.title}</h4>
                )}
                {item.badge && (
                  <Badge variant="secondary" className="text-[9px] uppercase tracking-wide" data-testid="highlight-badge">
                    {item.badge === "sponsorise" ? "Sponsorisé" : "Partenaire"}
                  </Badge>
                )}
              </div>
              {item.subtitle && (
                <p className="text-xs text-muted-foreground line-clamp-1 sm:line-clamp-2 mt-0.5">{item.subtitle}</p>
              )}
            </div>
            {item.cta_label && (
              <div className="shrink-0 hidden sm:block text-xs font-semibold text-[hsl(var(--aito-lagoon))] group-hover:underline">
                {item.cta_label} →
              </div>
            )}
          </div>
          {items.length > 1 && (
            <div className="flex items-center justify-center gap-1 pb-2">
              {items.map((_, i) => (
                <button
                  key={i}
                  aria-label={`Aller à la mise en avant ${i + 1}`}
                  onClick={(e) => { e.preventDefault(); setCurrent(i); }}
                  className={`h-1 rounded-full transition-all ${i === current ? "w-4 bg-[hsl(var(--aito-lagoon))]" : "w-1 bg-muted-foreground/30"}`}
                />
              ))}
            </div>
          )}
        </div>
      </Link>
      {/* CTA discret */}
      <div className="text-center mt-2">
        <Link
          to="/contact"
          className="text-[10px] text-muted-foreground hover:text-[hsl(var(--aito-lagoon))] transition-colors"
          data-testid="highlight-bottom-cta-contact"
        >
          Mettre en avant votre activité sur AITO.PF →
        </Link>
      </div>
    </div>
  );
}

export default HighlightBannerBottom;
